import auth from "./auth";
import users from "./users";
import patients from "./patient";
import registration from './registration';
import patientVisit from "./visits";
import patientAdmission from "./patientAdmission";
import inPatient from "./inpatient";
import discharge from "./discharge";
import radiology from "./radiology";
import lab from "./lab";
import theatre from "./theatre";
import morgue from "./morgue";
import outpatient from "./outpatient";
import billing from "./billing";

export default {
    auth, users, patients, registration,
    patientVisit, patientAdmission, inPatient,
    discharge, radiology, lab, theatre, morgue,outpatient,billing
}
